<template>
    <div v-if="media.length > 0" class="screen-shot-container">
        <swiper
            class="img-list-swiper"
            :options="swiperOptions"
        >
            <swiper-slide
                v-for="(item, index) in media"
                :key="item + '-' + index"
                class="img-item"
            >
                <img
                    v-if="item.type === 2"
                    :src="item.poster"
                    preview="99"
                    @load="refreshPreview"
                >
                <game-video
                    v-else
                    :poster="item.poster"
                    :src="item.url"
                    :index="index"
                    :item="{}"
                    :auto-play="index === 0"
                />
            </swiper-slide>
        </swiper>
        <div class="dot-wrapper" v-if="media.length > 1">
            <div
                v-for="(item, index) in media"
                :key="index"
                class="dot-item"
                :class="{'active': index === currentSwiperIndex}"
            ></div>
        </div>
    </div>
</template>

<script>
    import GameVideo from '../video/app-video-box'
    import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
    import 'swiper/dist/css/swiper.css';
    export default {
        components: {
            GameVideo,
            Swiper,
            SwiperSlide,
        },
        props: {
            media: {
                type: Array,
                required: true
            },
        },
        data() {
            return {
                swiperOptions: {
                    onSlideChangeEnd: swiper => {
                        this.currentSwiperIndex = swiper.realIndex;
                    },
                },
                currentSwiperIndex: 0,
            }
        },
        mounted() {
            if (this.media.length > 0) {
                this.doDisplayLog(this.media[0], 0);
            }
        },
        methods: {
            changeImage(index) {
                this.imageIndex = index;
                this.doDisplayLog(this.media[index], index);
            },
            refreshPreview() {
                this.$previewRefresh();
            },
            doDisplayLog(item, index) {
                this.$logger.display({
                    value: 'preview',
                    ext: {
                        item: [
                            {
                                id: '',
                                ext: Object.assign({
                                    previewType: item.type === 1 ? 'video' : 'picture'
                                }, this.$root.extData),
                                pos: index + 1
                            }
                        ]
                    }
                });
            },
            doClickLog(type, index) {
                let content = {
                    value: 'preview',
                    ext: {
                        id: '',
                        ext: Object.assign({
                            clickType: type
                        }, this.$root.extData),
                        pos: index + 1
                    }
                }
                this.$logger.click(content);
            }
        }
    };
</script>

<style lang="scss" scoped>
    @import "~@/common/style/mixin/utils";
    $design-width: 1242;
    .screen-shot-container {
        position: relative;
        .img-item {
            width: 100%;
            max-height: px2rem(699);
            img {
                width: 100%;
                height: auto;
                object-fit: cover;
            }
        }
        .gp-app-video {
            border-radius: 0;
        }
        .dot-wrapper {
            z-index: 2;
            position: absolute;
            bottom: px2rem(24);
            left: 50%;
            transform: translateX(-50%);
            display: flex;
            .dot-item {
                width: px2rem(15);
                height: px2rem(15);
                border-radius: 50%;
                background-color: #fff;
                opacity: .36;
                margin-right: px2rem(15);
                &.active {
                    opacity: 1;
                }
            }
        }
    }
</style>